import { DEFAULT_AVATAR_COLOR_TUPLE } from '@op/app-shared'
import { DEFAULT_AVATARS } from '@op/services'
import { memo } from 'react'
import { useResponsiveMemo } from '../../../../hooks'
import { AvatarWrapper } from '../../../Avatar/AvatarWrapper'
import { DEFAULT_AVATAR_IMAGES } from '../../../Avatar/constants'

type OnboardingAvatarProps = {
	readonly idx: number
}

export const OnboardingAvatar = memo(({ idx }: OnboardingAvatarProps) => {
	const { defaultColorIdx, defaultImgIdx } = DEFAULT_AVATARS[idx % DEFAULT_AVATARS.length]
	const Robot = DEFAULT_AVATAR_IMAGES.get()[defaultImgIdx]

	const size = useResponsiveMemo(({ fontScaled, matches }) =>
		Math.round(fontScaled(matches.sm ? 56 : 48)),
	)

	return (
		<AvatarWrapper border={false} padding={false} size={size}>
			<img
				alt="User Avatar"
				className="h-full w-full"
				src={Robot}
				style={{ backgroundColor: DEFAULT_AVATAR_COLOR_TUPLE[defaultColorIdx] }}
			/>
		</AvatarWrapper>
	)
})

OnboardingAvatar.displayName = 'OnboardingAvatar'
